import { RazorInputField, RazorModal } from "../../razor-reuse";
import imgToUse from "../../../assets/gif/confirm-check.gif";

interface myComponentProps {
  visible?: boolean;
  onClose?: () => void;
  title: string;
  onConfirm?: () => void;
  btnText?: string;
}

const SuccessModal = ({
  visible,
  onClose,
  title,
  onConfirm,
  btnText,
}: myComponentProps) => {
  return (
    <>
      <RazorModal
        dontShowClose
        outerClose
        visible={visible}
        onClose={onClose}
        onBtnClick={() => {}}
      >
        <div className="auth-confirm-signup-screen-modal-wrap">
          <div className="gif-box">
            <figure className="img-box">
              <img src={imgToUse} alt="" className="img" />
            </figure>
          </div>
          <p className="text">{title}</p>
          <RazorInputField
            color={`black-light`}
            value={btnText ?? "Proceed"}
            type="submit"
            className="btn"
            onSubmit={onConfirm}
          />
        </div>
      </RazorModal>
    </>
  );
};

export default SuccessModal;
